// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ChainDropdownMenu_dropdown__3DZ3t"};